
import { Product } from "../../classes"
import Store from "../../store"
const ProductModule = {
  namespaced: true,
  state: () => ({
    products: [],
    isLoading: false
  }),
  actions: {
    getProducts: async ({ commit }, payload) => {
      try {
        let user = Store.getters['user/getUser']
        commit("setProducts", []);
        commit("setIsLoading", true);
        const data = await Product.getProducts({ projectId: payload }, user ? user : null);
        commit("setProducts", data);
        commit("setIsLoading", false);
        return data;
      } catch (err) {
        commit("setIsLoading", false);
        return err;
      }
    }
  },
  getters: {
    getProducts: state => state.products,
    getIsLoading: state => state.isLoading,
  },
  mutations: {
    clearProduct: (state) => {
      state.products = [];
      state.isLoading = false;
    },
    setProducts: (state, products) => {
      state.products = products || [];
    },
    setIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    },
  },
};
export default ProductModule;
